export default "__VITE_ASSET__DYo4_iZv__"